import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router';
import TopLogo from '../components/TopLogo';
function Signin() {//
    const [details, setDetails] = useState({ email: "", password: "" });
    const [resend, setResend] = useState(false);
    const [err, setError] = useState({ color: 'black', data: '' });
    const submitting = () => {
        setResend(resend ? false : true);
    }
    useEffect(() => {
        // document.getElementsByClassName('nav-menu')[0].style.display = 'none'
        // document.getElementsByClassName('navbar')[0].style.display = 'none'

    }, [])
    let navigate = useNavigate();
    const submitHandler = e => {
        console.log(e.target)
        e.preventDefault();
        let div = document.getElementsByClassName('loadmain')[0];
        console.log(div)
        let notify = document.getElementsByClassName('noti')[0];
        if (!resend) {
            if (details.email.length >= 3 && details.password.length >= 3) {
                div.style.display = 'flex';
                axios.post(`${process.env.REACT_APP_API_URL1}/auth/jwt/create/`, {
                    email: details.email,
                    password: details.password,
                }).then(async response => {
                    // document.getElementsByClassName('nav-menu')[0].style.display = 'flex'
                    // document.getElementsByClassName('navbar')[0].style.display = 'block'
                    localStorage.setItem('access', response.data.access)
                    localStorage.setItem('refresh', response.data.refresh)
                    await axios.get(`${process.env.REACT_APP_API_URL1}/auth/users/me/`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `JWT ${response.data.access}`,
                            'Accept': 'application/json'
                        }
                    })
                        .then(response => {
                            div.style.display = 'none';
                            localStorage.setItem('userdet', JSON.stringify(response.data))
                            localStorage.setItem('type', response.data.type_of_account)
                            navigate('/dashboard')
                        }).catch(err => {
                            div.style.display = 'none';
                            console.log(err)
                            if(err.response.status==500){
                                try {
                                    notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                                    Server busy, Please try after some time
                                    </div>`;
                                    setTimeout(() => {
                                        notify.removeChild(notify.lastChild)
                                    }, 3000);
                                } catch (e) { console.log(e) }
                            }
                        })
                }).catch(err => {
                    console.log(err)
                    // setError(err)
                        if(err.response.status==500){
                            try {
                                notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                                Server busy, Please try after some time
                                </div>`;
                                setTimeout(() => {
                                    notify.removeChild(notify.lastChild)
                                }, 3000);
                            } catch (e) { console.log(e) }
                        }
                    div.style.display = 'none';
                    setError({ color: 'red', data: 'Wrong Password' })
                })
            } else { setError({ color: 'red', data: 'Enter all input Feilds' }) }
        }
        else {
            if (details.email.length >= 3) {
                div.style.display = 'block';
                axios.post(`${process.env.REACT_APP_API_URL1}/auth/users/reset_password/`, {
                    email: details.email,
                }).then(response => {
                    div.style.display = 'none';
                    setError({ color: 'green', data: 'Reset Password Link Sent to Your Mail' })
                }).catch(err => {
                    console.log(err)
                    div.style.display = 'none';
                    setError({ color: 'red', data: 'Enter Email Feild' })
                })
            } else { setError({ color: 'red', data: 'Enter Email Feild' }) }

        }
    }
    const styles = {
        backgroundColor: '#e5f4f1',
        borderBottom: ' 2px solid #0052b5',
        transition: '5ms'
    };
    const showButton = () => {
        console.log('resized')
        setR(window.innerHeight)
    }
    useEffect(() => {
        // document.getElementsByClassName('nav-menu')[0].style.display = 'none'
        // document.getElementsByClassName('navbar')[0].style.display = 'none'
        // window.onresize = showButton;
        window.addEventListener("resize", showButton);
        return () => {
            window.removeEventListener("resize", showButton)
        }
    }, [])
    const [ratio, setR] = useState(window.innerHeight)
    return (
        <div className='signindiv'>
            {/* <TopLogo /> */}
            <img className='fixed' src={require('../IMAGES/background.png')} />
            <form className='oth' onSubmit={(e) => submitHandler(e)}>
                <div style={{ transform: `scale(${(ratio / 500) * 0.7})` }} className='form-inner'>
                    <div className='row linksSignup'>
                        <Link to='/SignIn'><button className='mainbutton' style={styles}>Sign in</button></Link>
                        <Link to='/SignUp'><button className='mainbutton'>Sign up</button></Link>
                    </div>
                    <div style={{ color: err.color }} className='error'>{err.data}</div>
                    <div className='form-group'>
                        <label htmlfor='email'></label>
                        <input type="text" name='email' id='email' placeholder='Email..' onChange={e => setDetails({ ...details, email: e.target.value })} value={details.email} />
                    </div>
                    <div className='form-group' style={{ display: resend ? 'none' : 'block' }}>
                        <label htmlfor="password"></label>
                        <input type="password" name='password' id='password' placeholder='Password..' onChange={e => setDetails({ ...details, password: e.target.value })} value={details.password} />
                    </div>
                    <div className='Forgot_password'><button className='Forgot_password' onClick={() => navigate('/ResetPass')}>{resend ? 'back' : 'Forgot Password'}</button></div>
                    <div className='all'>
                        <button className='signupbutton'>{resend ? 'Send Reset Link' : 'Sign In'}</button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default Signin;